import { style } from '../layer.css.ts';
import { themeV2 } from '../theme-v2/vars.ts';
import { space } from '../tokens';
import { typography } from '../typography';
import { ellipsis } from '../utility.css.ts';

export const handleV2 = style({
  display: 'flex',
  alignItems: 'center',
  gap: space.s8,
  minWidth: 0,
  isolation: 'isolate',
  color: 'inherit',
  textDecoration: 'none',
  selectors: {
    '&:focus': {
      outline: 'none',
    },
    '&:focus-visible': {
      outline: `2px solid ${themeV2.color.border.focus}`,
      outlineOffset: 2,
    },
  },
});

export const handleV2Label = style([
  ellipsis,
  {
    ...typography.bodySm,
    color: themeV2.color.text.quaternary,
    selectors: {
      [`${handleV2}:hover &`]: {
        color: themeV2.color.text.primary,
        textDecoration: 'underline',
      },
    },
  },
]);
